import React, { useState } from 'react';
import { Card, Container, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Route, Routes, Link, Navigate, useNavigate } from 'react-router-dom';

function Info() {
  const { t, i18n } = useTranslation();

  const EnglishAboutDB = () => {
    return (
      <div>
        <p>
          The public database "Latviešu karavīri" ("Latvian Soldiers") provides access to the
          lists of Latvian soldiers who served in the First and Second World Wars and are held
          by the Latvian War Museum.
        </p>
        <p>
          The database is intended for both professional researchers and family historians, as
          well as other interested users. The information found in the database may only be
          used for research, education, or family research purposes.
        </p>
        <p>
          In the future, the database will be supplemented with additional soldier lists that are
          held by or entrusted to the Latvian War Museum.
        </p>
        <p>
          To improve and enrich the information available in the database, users may suggest
          corrections or additions. This can be done in the section "Suggest a Correction" or by
          writing to the email address: <a href="mailto:datubaze@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datubaze@karamuzejs.lv</a>
        </p>
        <h5>First World War Lists</h5>
        <p>
          The lists of Latvian riflemen from the First World War and the Russian Civil War were
          compiled in the late 1950s by former Latvian rifleman Ādolfs Klēbergs. At present,
          information about Latvian riflemen is available from the following lists:
        </p>
        <ol>
          <li>
            List of soldiers serving in Latvian Rifle Battalions (Regiments) (around 25,000
            soldiers)
          </li>
          <li>
            List of fallen, missing, wounded and captured Latvian Riflemen (~ 3,700)
          </li>
          <li>
            List of awarded soldiers of the 2nd Latvian Rifle Brigade (~2,150)
          </li>
        </ol>
        <p>
          Information about the same person may appear in two or even all three lists. Birth
          data is very rarely included in the Latvian riflemen lists; therefore, it is recommended
          to search only by first name and surname. For many riflemen, the father's or
          mother's name is provided, as well as the place of birth or last place of residence,
          which helps with identification.
        </p>
        <h5>Second World War Lists</h5>
        <p>
          Information about Latvian inhabitants who served in German military units during the
          Second World War comes from the Daugavas Vanagi Latvian Legion archive, which
          has been kept at the Latvian War Museum since 2004. At present, the following lists
          are available:
        </p>
        <ol>
          <li>
            List of soldiers mobilized in the Latvian SS Legion (around 75,400 soldiers)
          </li>
          <li>
            List of Latvian soldiers in the Zedelgem (Belgium) prisoner-of-war camp (~11,500)
          </li>
          <li>
            List of fallen and missing Latvian SS Legion soldiers (~18,900)
          </li>
        </ol>
      </div>
    );
  };

  const LVAboutDB = () => {
    return (
      <div>
        <p>
          Publiskā datubāze &quot;Latviešu karavīri&quot; piedāvā iespēju piekļūt Latvijas Kara muzeja
          rīcībā esošajiem Pirmajā un Otrajā pasaules karā dienējušo Latvijas iedzīvotāju
          sarakstiem.
        </p>
        <p>
          Datubāze ir paredzēta gan profesionāliem pētniekiem, gan dzimtas pētniekiem un
          citiem interesentiem. Datubāzē atrodamā informācija izmantojama tikai pētniecības,
          izglītības vai dzimtas pētniecības nolūkiem.
        </p>
        <p>
          Datubāzi nākotnē plānots papildināt ar citiem Latvijas Kara muzeja rīcībā esošiem
          vai muzejam uzticētiem karavīru sarakstiem.
        </p>
        <p>
          Lai pilnveidotu un papildinātu datubāzē atrodamo informāciju, lietotājiem ir iespēja
          ieteikt labojumu vai papildinājumu, ko var veikt sadaļā "Ieteikt labojumu" vai rakstot
          uz e-pastu: <a href="mailto:datubaze@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datubaze@karamuzejs.lv</a>
        </p>
        <h5>Pirmā pasaules kara saraksti</h5>
        <p>
          Pirmā pasaules kara un Krievijas Pilsoņu kara laika latviešu strēlnieku sarakstus 20.
          gadsimta 50. gadu beigās sastādījis bijušais latviešu strēlnieks Ādolfs Klēbergs.
        </p>
        <p>Šobrīd par latviešu strēlniekiem pieejama informācija no sekojošiem sarakstiem:</p>
        <ol>
          <li>
            Latviešu strēlnieku bataljonos (pulkos) dienējušo saraksts (ap 25 000
            karavīru)
          </li>
          <li>
            Kritušie, bez vēsts pazudušie, ievainotie un gūstā nonākušie latviešu strēlnieki
            (~ 3 700)
          </li>
          <li>
            Latviešu strēlnieku 2. brigādes apbalvoto virsnieku un karavīru saraksts (~ 2
            150)
          </li>
        </ol>
        <p>
          Par vienu un to pašu personu var būt atrodama informācija divos vai pat visos trijos
          sarakstos. Latviešu strēlnieku sarakstos ļoti reti parādās dzimšanas dati, tādēļ
          ieteicams meklēt tikai pēc vārda un uzvārda. Daudziem strēlniekiem ir minēti tēva vai
          mātes vārds, kā arī dzimšanas vai pēdējā dzīves vieta, kas atvieglo karavīra
          identificēšanu.
        </p>
        <h5>Otrā pasaules kara saraksti</h5>
        <p>
          Informācija par Otrā pasaules karā vācu militārajās vienībās dienējušajiem Latvijas
          iedzīvotājiem nāk no Daugavas Vanagu Latviešu leģiona arhīva, kas kopš 2004.
          gada glabājas Latvijas Kara muzejā. Šobrīd pieejama informācija no sekojošiem
          sarakstiem:
        </p>
        <ol>
          <li>
            Latviešu SS leģionā mobilizēto saraksts (ap 75 400 karavīru)
          </li>
          <li>
            Zedelgemas (Beļģija) karagūstekņu nometnē ieslodzīto latviešu karavīru
            saraksts (11 500)
          </li>
          <li>
            Kritušo un bez vēsts pazudušo Latviešu SS leģiona karavīru saraksts (18 900)
          </li>
        </ol>
      </div>
    );
  };

  const EnglishPrivacyPolicy = () => {
    return (
      <div>
        <p>
          This website is owned by, and the controller of the personal data processed on it is, the Latvian War Museum, Reg. No. 90000020203, Smilšu Street 20, Riga, LV-1050, telephone: +371 63616238, e-mail: <a href="mailto:pasts@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>pasts@karamuzejs.lv</a>.
        </p>
        <p>
          To use the full functionality of this website, you agree to the processing of your personal data for the purpose of ensuring that the website is accessible only to registered users. The Latvian War Museum does not collect, process, or store personal data after the use of the website has ended.
        </p>
        <p>
          If you have any questions regarding the processing of personal data on this website, please contact the Latvian War Museum's data protection specialists by writing to: <a href="mailto:datuaizsardziba@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datuaizsardziba@karamuzejs.lv</a>.
        </p>
        <p>
          Please note that the publicly accessible Latvian War Museum database "Latvian Soldiers" contains information about residents of Latvia who served in the First and Second World Wars. If you are included in this database and have questions about the processing of your personal data, please contact the Latvian War Museum's data protection specialists by writing to: <a href="mailto:datuaizsardziba@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datuaizsardziba@karamuzejs.lv</a>.
        </p>
        <p>
          <strong>Gratitude</strong><br/>
          The public database “Latvian Soldiers” was created with the financial support of the State Culture Capital Foundation.
          The Latvian War Museum expresses its gratitude for the assistance in creating the database to Gints Ošis, Andrejs Bundžs, Anete Elīza Andersone, Viesturs Vēzis, Ivo Dzērve, Kaspars Vītols, Udo Intis Sietiņš, Emīls Gailis, Aivars Sinka, Gita Bulaha, Klāvs Zariņš.
        </p>
      </div>
    );
  };

  const LVPrivacyPolicy = () => {
    return (
      <div>
        <p>
          Šī tīmekļa vietne pieder un tajā apstrādāto personu datu pārzinis ir Latvijas Kara muzejs, Reģ. Nr. 90000020203, Smilšu iela 20, Rīga, LV-1050, tālrunis: 63616238, elektroniskā pasta adrese: <a href="mailto:pasts@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>pasts@karamuzejs.lv</a>
        </p>
        <p>
          Lai izmantotu šīs tīmekļa vietnes pilnu funkcionalitāti, Jūs piekrītat savu personas datu apstrādei, kuras mērķis ir nodrošināt tīmekļa vietnes izmantošanu tikai reģistrētiem lietotājiem. Latvijas Kara muzejs neievāc, neapstrādā un neglabā personas datus pēc tīmekļa vietnes izmantošanas.
        </p>
        <p>
          Gadījumā, ja Jums ir radušies jautājumi par personu datu apstrādi šajā tīmekļa vietnē, tad lūdzu sazinieties ar Latvijas Kara muzeja datu aizsardzības speciālistiem, rakstot uz e-pasta adresi: <a href="mailto:datuaizsardziba@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datuaizsardziba@karamuzejs.lv</a>.
        </p>
        <p>
          Informējam, ka publiski pieejamā Latvijas Kara muzeja datu bāze "Latviešu karavīri" satur informāciju par Pirmajā un Otrajā pasaules karā dienējušajiem Latvijas iedzīvotāju sarakstiem. Ja esat iekļauts šajā datu bāzē un Jums ir jautājumi par savu personas datu apstrādi, lūdzam sazināties ar Latvijas Kara muzeja datu aizsardzības speciālistiem, rakstot uz e-pasta adresi: <a href="mailto:datuaizsardziba@karamuzejs.lv" style={{ color: 'blue', textDecoration: 'underline' }}>datuaizsardziba@karamuzejs.lv</a>.
        </p>
        <p>
          <strong>Pateicības</strong><br/>
          Publiskā datubāze “Latviešu karavīri” tapusi ar Valsts kultūrkapitāla fonda finansiālu atbalstu.
          Latvijas Kara muzejs izsaka pateicību par palīdzību datubāzes tapšanā Gintam Ošim, Andrejam Bundžam, Anetei Elīzai Andersonei, Viesturam Vēzim, Ivo Dzērvem, Kasparam Vītolam, Udo Intim Sietiņam, Emīlam Gailim, Aivaram Sinkam, Gitai Bulahai, Klāvam Zariņam.
        </p>
      </div>
    );
  };

  return (
    <Container>
      <Card className="w-70 text-center p-4 shadow-lg rounded">
        <h3 className="mb-4">{t('Publiskā datubāze "Latviešu karavīri"')}</h3>

        {/* About the Database Section */}
        <section className="mb-4 text-start">
          <h4>{t('Par datubāzi')}</h4>
          <div className="text-muted">
            {i18n.language === 'lv' ? <LVAboutDB /> : <EnglishAboutDB />}
          </div>
        </section>

        <hr />

        {/* Privacy Policy Section */}
        <section className="mb-4 text-start">
          <h4>{t('Privātuma atruna')}</h4>
          <div className="text-muted">
            {i18n.language === 'lv' ? <LVPrivacyPolicy /> : <EnglishPrivacyPolicy />}
          </div>
        </section>

        <hr />

        {/* Contact Section */}
        <section>
          <h4 className="text-start">{t('Kontakti')}</h4>
          <p className="text-muted text-start mb-1">
            {t('Atbildīgā institūcija')}: <a href="https://www.karamuzejs.lv/" className="text-decoration-none">Latvijas Kara muzejs</a>
          </p>
          <p className="text-muted text-start mb-1">
            {t('E-pasts saziņai')}: <a href="mailto:datubaze@karamuzejs.lv" className="text-decoration-none">datubaze@karamuzejs.lv</a>
          </p>
           <p className="text-muted text-start mb-0">
            {t('Izstrādātāji')}: SIA Thinkitive Lab
          </p>
        </section>
      </Card>
    </Container>
  );
}

export default Info;